import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { ClientRegisterForm } from '@/features/auth/components/ClientRegisterForm';

export const Route = createFileRoute('/client_/register/')({ component: Page });

function Page() {
  return (
    <AuthLayout formSide="right" brandPanel={<ClientAuthBrandPanel />}>
      <ClientRegisterForm />
    </AuthLayout>
  );
}
